function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "656654E3-D129-4BDF-83EF-061B7426F049");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Home--NEW",
  transform: "translate(-927.000000, -683.000000)"
}, React.createElement("g", {
  id: "Thumbnail-#2-Copy-4",
  transform: "translate(927.000000, 683.000000)"
}, React.createElement("g", {
  id: "slika"
}, React.createElement("rect", {
  id: "background-copy",
  fill: "#FDF2EC",
  x: 0,
  y: 0,
  width: 68,
  height: 56,
  rx: 4
}), React.createElement("path", {
  d: "M4,4 L4,52 L64,52 L64,4 L4,4 Z M4,0 L64,0 C66.209139,0 68,1.790861 68,4 L68,52 C68,54.209139 66.209139,56 64,56 L4,56 C1.790861,56 0,54.209139 0,52 L0,4 C0,1.790861 1.790861,0 4,0 Z",
  id: "Border-Copy",
  fill: "#FDD6C1",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M18.5,24 C14.3578644,24 11,20.6421356 11,16.5 C11,12.3578644 14.3578644,9 18.5,9 C22.6421356,9 26,12.3578644 26,16.5 C26,20.6421356 22.6421356,24 18.5,24 Z M18.5,20 C20.4329966,20 22,18.4329966 22,16.5 C22,14.5670034 20.4329966,13 18.5,13 C16.5670034,13 15,14.5670034 15,16.5 C15,18.4329966 16.5670034,20 18.5,20 Z",
  id: "Oval-2",
  fill: "#FDD6C1",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M14.4080878,47.4203129 C13.6236707,48.1979783 12.3573526,48.192505 11.5796871,47.4080878 C10.8020217,46.6236707 10.807495,45.3573526 11.5919122,44.5796871 L28.0412661,28.2719172 L37.3125607,36.3361058 C38.1459773,37.061013 38.2339415,38.3242841 37.5090343,39.1577007 C36.784127,39.9911173 35.5208559,40.0790816 34.6874393,39.3541743 L28.2191938,33.7280828 L14.4080878,47.4203129 Z",
  id: "Path-4",
  fill: "#FDD6C1",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M29.4142766,47.4141505 C28.6332628,48.1952339 27.3669329,48.1952904 26.5858495,47.4142766 C25.8047661,46.6332628 25.8047096,45.3669329 26.5857234,44.5858495 L52.9083918,18.2608342 L67.3190784,30.9052264 C68.1493503,31.6337332 68.2318472,32.8973731 67.5033404,33.7276451 C66.7748335,34.5579171 65.5111936,34.640414 64.6809216,33.9119071 L53.0871507,23.7391658 L29.4142766,47.4141505 Z",
  id: "Path-4",
  fill: "#FDD6C1",
  fillRule: "nonzero"
})))));

var SvgImagePlaceholder = function SvgImagePlaceholder(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "68px",
    height: "56px",
    viewBox: "0 0 68 56",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgImagePlaceholder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/image_placeholder.befa9808.svg";
export { ForwardRef as ReactComponent };